declare const window: Window & { dataLayer: Record<string, unknown>[] };

export const logEvent = (event, variables = {}) => {
  window.dataLayer.push({
    event,
    ...variables,
  });
};
